import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { call, put, select } from 'redux-saga/effects';
import { streamActions, withOffset } from '../../Stream';
import { requestPuppy } from '@wix/da-http-client';
import { getCurrentMediaSource, getGallectionById, getCurrentFolderId, getGrusername } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { normalizeGallection } from '../../redux/normalizr/helpers';
export default function*(action) {
    const { folderId, toFolderId } = action.payload;
    const mediaSource = yield select(getCurrentMediaSource);
    const currentFolderId = yield select(getCurrentFolderId);
    const gallection = yield select(getGallectionById, folderId);
    const username = yield select(getGrusername);
    if (!gallection) {
        return;
    }
    const streamId = getGallectionStreamId(mediaSource, currentFolderId);
    yield put(streamActions.deleteItem({
        streamId,
        item: folderId
    }));
    const updatedGallection = _object_spread_props(_object_spread({}, gallection), {
        parentId: toFolderId !== null && toFolderId !== void 0 ? toFolderId : null
    });
    const entities = normalizeGallection(updatedGallection);
    yield put(streamActions.deleteItem({
        streamId,
        item: folderId
    }));
    const moveToStreamId = getGallectionStreamId(mediaSource, toFolderId);
    yield put(withOffset.actions.insertItems({
        streamId: moveToStreamId,
        items: [
            folderId
        ],
        offset: 0,
        entities
    }));
    var _getGallectionType;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(mediaSource)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: folderId,
        to_folderid: toFolderId
    };
    yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/move',
        data: params
    });
}

//# sourceMappingURL=moveGallection.js.map